export default "/assets/site/images/negelle_anna.png?b24a38b8f35f07f88a49af2093eec86a";